import { ADD_PRODUCT_RECOMMEND } from '@/typed-graphql/mutation';
import { gql, useMutation } from '@apollo/client';
import { useEffect } from 'react';

export const useProductViewRecord = (productId?: number) => {
  const [reqAddProductRecommend] = useMutation(gql(ADD_PRODUCT_RECOMMEND));

  useEffect(() => {
    if (!productId) return;

    const email = getLocalStorageEmail();

    if (!email) return;

    reqAddProductRecommend({
      variables: {
        input: {
          email,
          product_id: productId,
        },
      },
    }).catch(() => {});
  }, [productId, reqAddProductRecommend]);

  return {
    setLocalStorageEmail,
    getLocalStorageEmail,
  };
};

const STORAGE_EMAIL_KEY = `${process.env.NEXT_PUBLIC_STORE_VIEW_CODE}-p-email`;

const setLocalStorageEmail = (email: string) => {
  if (!email) return;

  try {
    window.localStorage.setItem(STORAGE_EMAIL_KEY, email);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Failed to set email in localStorage:', error);
    }
  }
};

const getLocalStorageEmail = (): string | null => {
  try {
    return window.localStorage.getItem(STORAGE_EMAIL_KEY);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Failed to get email from localStorage:', error);
    }
  }

  return null;
};
